import { Card, Heading, CardBody, CardHeader, TrackScrolledIntoView } from '@homebotapp/hb-react-component-catalog'
import { PaidSoFar } from './PaidSoFar'
import { defineMessages, useIntl } from 'react-intl'
import { PrincipalAndInterestExplanation } from './PrincipalAndInterestExplanation/PrincipalAndInterestExplanation'
import { HOMEOWNER_DIGEST_PRINCIPLE_AND_INTEREST_MODULE } from '../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'
import { PRINCIPAL_INTEREST } from '../../../constants/document_ids'

export const MSG = defineMessages({
  head: {
    id: 'Homeowner.interestCard.headline',
    defaultMessage: "What you've paid so far"
  }
})

export interface PrincipalAndInterestModuleProps {
  withCurrentHomeData: boolean
}

export const PrincipalAndInterestModule = ({ withCurrentHomeData }: PrincipalAndInterestModuleProps) => {
  const intl = useIntl()

  return (
    <TrackScrolledIntoView
      tracking={{
        guid: '3nCw6DJZ9ZxPckqwckLaX4',
        ui_context: HOMEOWNER_DIGEST_PRINCIPLE_AND_INTEREST_MODULE,
        descriptor: MSG.head.defaultMessage
      }}
    >
      <Card
        size='lg'
        data-qa='InterestCard'
        id={PRINCIPAL_INTEREST}
        scrollMarginTop='var(--digest-module-scroll-margin-top)'
      >
        <CardHeader data-qa='interestSectionHeadline'>
          <Heading fontWeight='light' size='md' marginBottom={0}>
            {intl.formatMessage(MSG.head)}
          </Heading>
        </CardHeader>
        <CardBody>
          <PaidSoFar withCurrentHomeData={withCurrentHomeData} />
          <PrincipalAndInterestExplanation withCurrentHomeData={withCurrentHomeData} />
        </CardBody>
      </Card>
    </TrackScrolledIntoView>
  )
}
